import { createActionsHook } from 'src/lib/sweetState';

import Container from './Container';
import Store from './Store';

const useActions = createActionsHook(Store);

export { Container, Store, useActions };
